/* SOLEN — mobile-menu.js
   Hamburger menu toggle. Mobile only (button hidden on desktop). */
(function () {
  'use strict';

  var menu = document.getElementById('MobileMenu');
  if (!menu) return;

  function toggles() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-menu-open]'));
  }
  function openMenu() {
    menu.setAttribute('aria-hidden', 'false');
    toggles().forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menu.setAttribute('aria-hidden', 'true');
    toggles().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]') && !e.target.closest('.mobile-menu')) {
      e.preventDefault();
      openMenu();
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      closeMenu();
      return;
    }
    if (e.target.closest('.mobile-menu-links a')) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();
